import { observable } from 'mobx';
import {
    IComponentViewController,
    IViewControllerData,
    ViewControllerLoadedMethod
} from '@estee/elc-universal-utils';

export class ViewController implements IComponentViewController {
    public id?: string;
    public dataState?: IViewControllerData;
    public loaded?: ViewControllerLoadedMethod;
    public configMergeStrategy?: Function;
    @observable public isLoading: boolean = true;

    public setSSRState = (data?: IViewControllerData) => {
        this.dataState = data;
    };

    public setId = (id?: string) => {
        this.id = id && btoa(unescape(encodeURIComponent(id)));
    };

    public get data(): IViewControllerData {
        return {};
    }
}
